import { autoReplyMessageStrings } from 'constants/strings';
import {
  AUTO_REPLY_CHAT_LINK_BUTTON_MAX_LENGTH,
  AUTO_REPLY_CHAT_LINK_TEXT_MAX_LENGTH,
} from './constants';
import { ToggleRow } from './ToggleRow';

type Props = {
  enabled: boolean;
  text: string;
  buttonLabel: string;
  disabled: boolean;
  description: string;
  onEnabledChange: (enabled: boolean) => void;
  onTextChange: (text: string) => void;
  onButtonLabelChange: (label: string) => void;
};

const strings = autoReplyMessageStrings.chatLink;

/** チャットリンクのON/OFFと、CTAとして送る文言の編集欄。 */
export function ChatLinkFields({
  enabled,
  text,
  buttonLabel,
  disabled,
  description,
  onEnabledChange,
  onTextChange,
  onButtonLabelChange,
}: Props) {
  // 表示は保存値のまま。プランで操作だけ止め、値は書き換えない。
  const showFields = enabled && !disabled;

  return (
    <div className="grid gap-3">
      <ToggleRow
        checked={enabled}
        onChange={onEnabledChange}
        label={strings.label}
        description={disabled ? strings.lightPlanNote : description}
        disabled={disabled}
      />
      {showFields ? (
        <div className="grid gap-3 rounded-2xl border border-border/70 bg-white p-4">
          <label className="grid gap-1">
            <span className="text-xs font-semibold text-ink">
              {strings.textFieldLabel}
            </span>
            <textarea
              value={text}
              onChange={(event) => onTextChange(event.target.value)}
              placeholder={strings.previewText}
              maxLength={AUTO_REPLY_CHAT_LINK_TEXT_MAX_LENGTH}
              rows={2}
              className="rounded-xl border border-border p-3 text-sm outline-none focus:border-accent"
            />
          </label>
          <label className="grid gap-1">
            <span className="text-xs font-semibold text-ink">
              {strings.buttonFieldLabel}
            </span>
            <input
              value={buttonLabel}
              onChange={(event) => onButtonLabelChange(event.target.value)}
              placeholder={strings.previewButton}
              maxLength={AUTO_REPLY_CHAT_LINK_BUTTON_MAX_LENGTH}
              className="rounded-xl border border-border p-3 text-sm outline-none focus:border-accent"
            />
          </label>
          <p className="text-xs text-muted">{strings.blankNote}</p>
        </div>
      ) : null}
    </div>
  );
}
